const en = {
  eyebrow: "FAQ",
  title: "Common questions",

  items: [
    {
      q: "What courses do you offer?",
      a: "We offer live, interactive courses in programming and software engineering: AI and machine learning, algorithm design, programming fundamentals, software architecture, web development, mobile development, and database and server development, from beginner to advanced.",
    },
    {
      q: "Do I need prior experience to join?",
      a: "No prior experience is required. Our courses accommodate all levels, from complete beginners to experienced programmers. You can start from zero, and we'll guide you step by step.",
    },
    {
      q: "How are the courses conducted?",
      a: "All courses are conducted live online by expert instructors. Sessions are interactive, with hands-on projects and real-time feedback. Miss a session? We provide recordings to review later.",
    },
    {
      q: "What programming languages do you teach?",
      a: "Depending on the course: Python, JavaScript, HTML and CSS, React, Swift, Kotlin and SQL. You'll learn the right tools and languages for the field you're training for.",
    },
    {
      q: "How can I enroll in a course?",
      a: "Browse the available courses, pick the one that suits your level, and sign up. You'll receive everything you need to get started. Need help choosing? Our team is here to assist.",
    },
    {
      q: "Do you provide course certificates?",
      a: "Yes. On completion you receive a certificate verifying your new skills, a useful addition to your resume or portfolio.",
    },
    {
      q: "How long do the courses take?",
      a: "Durations vary by subject. Some are intensive and finish in a few weeks, others span several months. Each course page details the time commitment.",
    },
    {
      q: "What if I have questions during the course?",
      a: "Live courses are interactive, so ask questions any time. There is also support outside class through the community forum and one-on-one sessions.",
    },
  ],
};

export default en;
